import * as React from "react";
import {Units} from "../model/settings/Units";

export type SettingsContextType = {
    units: Units;
    setUnits: (units: Units) => void
};

export const SettingsContext = React.createContext<SettingsContextType | null>(null);
